import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getProdukSupplier = createAsyncThunk('/dashboardproduk/content', async () => {
    const userId = localStorage.getItem("userId");

    try {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listProductSupplier/${userId}`, {})
    return response.data;
    } catch (err) {
        if (err.response && err.response.status === 401) {
            sessionStorage.removeItem("sensitiveAccess");
            sessionStorage.removeItem("sensitiveAccessSo");
            
            localStorage.clear();

            window.location.href = '/login';
        } 
    }
})

export const dashboardSlice = createSlice({
    name: 'dashboardproduk',
    initialState: {
        isLoading: false,
        dashboardproduk : []
    },

    /*extraReducers: {
        [getProdukSupplier.pending]: state => {
			state.isLoading = true
		},
        [getProdukSupplier.fulfilled]: (state, action) => {
            state.dashboardproduk = action.payload.data
			state.isLoading = false
		},
        [getProdukSupplier.rejected]: state => {
			state.isLoading = false
		},
    }*/
    extraReducers: (builder) => {
        builder
          .addCase(getProdukSupplier.pending, (state) => {
            state.isLoading = true;             
            })
            .addCase(getProdukSupplier.fulfilled, (state, action) => {          
                state.dashboardproduk = action.payload.data;
                state.isLoading = false;             
            })
            .addCase(getProdukSupplier.rejected, (state) => {
                state.isLoading = false;             
            });
      },        
})

export default dashboardSlice.reducer